var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "cnt-slider" }, [
    _c(
      "div",
      { staticClass: "lst-slider" },
      [
        _c(
          "slick",
          {
            ref: "slick_exchanges",
            staticClass: "slider-row slick",
            attrs: { options: _vm.slickOptions }
          },
          _vm._l(_vm.summarys, function(item) {
            return _c("li", { key: item.currency_id }, [
              _c("div", { staticClass: "box-news" }, [
                _c("div", { staticClass: "box-heading" }, [
                  _c("div", { staticClass: "exchange-title" }, [
                    _vm._v(_vm._s(_vm.$t("summary.summary_exchange")))
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "unit-date" }, [
                    _vm._v(_vm._s(_vm.utils.getCurrencyName(item.currency_id)))
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "summary-exchange" }, [
                  _c("div", { staticClass: "cnt-item" }, [
                    _c("div", { staticClass: "ttl" }, [
                      _vm._v(_vm._s(_vm.$t("summary.label.initial_carry_cash")))
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "num" }, [
                      _vm._v(
                        _vm._s(
                          _vm.utils.formatPrice(
                            item.exchanges.initial_carry_cash,
                            item.currency_id
                          )
                        )
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "cnt-item" }, [
                    _c("div", { staticClass: "ttl" }, [
                      _vm._v(_vm._s(_vm.$t("summary.label.exchange_in")))
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "num" }, [
                      _vm._v(
                        _vm._s(
                          _vm.utils.formatPrice(
                            item.exchanges.exchange_in,
                            item.currency_id
                          )
                        )
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "cnt-item" }, [
                    _c("div", { staticClass: "ttl" }, [
                      _vm._v(_vm._s(_vm.$t("summary.label.exchange_out")))
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "num" }, [
                      _vm._v(
                        _vm._s(
                          _vm.utils.formatPrice(
                            item.exchanges.exchange_out,
                            item.currency_id
                          )
                        )
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "cnt-item deduction" }, [
                    _c("div", { staticClass: "ttl ttl-total" }, [
                      _vm._v(_vm._s(_vm.$t("summary.label.deduction")))
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "num" }, [
                      _vm._v(
                        _vm._s(
                          _vm.utils.formatPrice(
                            item.exchanges.deduction,
                            item.currency_id
                          )
                        )
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "cnt-item" }, [
                    _c("div", { staticClass: "ttl" }, [
                      _vm._v(_vm._s(_vm.$t("summary.label.carry_cash_balance")))
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "num" }, [
                      _vm._v(
                        _vm._s(
                          _vm.utils.formatPrice(
                            item.carry_cashs.expenditure -
                              0 +
                              (item.carry_cashs.income - 0),
                            item.currency_id
                          )
                        )
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "cnt-item" }, [
                    _c("div", { staticClass: "ttl" }, [
                      _vm._v(
                        _vm._s(_vm.$t("summary.label.local_income_balance"))
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "num" }, [
                      _vm._v(
                        _vm._s(
                          _vm.utils.formatPrice(
                            item.local_incomes.total != null
                              ? item.local_incomes.total
                              : 0,
                            item.currency_id
                          )
                        )
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "cnt-item total" }, [
                    _c("div", { staticClass: "ttl ttl-total" }, [
                      _vm._v(_vm._s(_vm.$t("summary.label.remaining_balance")))
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "num" }, [
                      _vm._v(_vm._s(_vm.utils.formatPrice(item.total)))
                    ])
                  ])
                ])
              ])
            ])
          }),
          0
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-72a24d25", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72a24d25","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/common/Summary/ExchangeSummary.vue
// module id = null
// module chunks = 